import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { IFaqs, IQuestionsAndAnswers } from 'src/app/model/http/faqs.model';
import { ILandingPage } from 'src/app/model/http/landing.model';
import { DataService } from 'src/app/services/data.service';
import { StrappiService } from 'src/app/services/strappi.service';

@Component({
  selector: 'app-landing-general',
  templateUrl: './landing-general.component.html',
  styleUrls: ['./landing-general.component.scss']
})
export class LandingGeneralComponent implements OnInit {
  data: ILandingPage[] = [];
  dataLandingPage: ILandingPage[] = [];
  questions: ILandingPage = {
    id: 0,
    hasSubtitle: false,
    hasPrecontent: false,
    content: '',
    isQuestion: false,
    published_at: '',
    created_at: '',
    updated_at: '',
    questions: [],
  };
  constructor(
    private strappiService: StrappiService,
    private dataService: DataService,
    private router: Router,
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.strappiService.getLandingPage().subscribe(
      (res) => {
        this.data = res;
        this.getQuestions();
        this.dataService.setSideLandingMenu(this.data);

        let _path = this.router.url.split('#');
        let _pathame: any = this.data.filter((_data) => {
          return _data.url === _path[1] ? _data.route : '';
        });


        if (_pathame.length > 0 && _pathame[0]?.route) {
          this.setTitle(`${_pathame[0].route}`);
        }        
      }
    );
  }


  setTitle(title: any) {
    this.titleService.setTitle(`BitCar - ${title}`);
  }

  getQuestions() {
    this.strappiService.getFaqs().subscribe(
      (res) => {
        this.mapQuestions(res);
      }
    );
  }

  mapQuestions(data: IFaqs) {
    this.questions.route = data.header?.title;
    this.questions.hasSubtitle = false;
    this.questions.hasPrecontent = true;
    this.questions.isQuestion = true;
    this.questions.url = 'faqs';
    data.preguntas_respuestas?.map((question, index) => {
      let faq: IQuestionsAndAnswers = {
        id: 0,
        question: '',
        answer: '',
        link: '',
        status: false,
        quick_answer: ''
      };
      faq.id = index;
      faq.question = question.question;
      faq.answer = question.answer;
      faq.link = question.link;
      faq.status = question.status;
      faq.quick_answer = question.quick_answer;
      this.questions.questions?.push(faq);
    });
    this.data.push(this.questions);
    this.dataLandingPage = this.data;
  }

}
